/**
 * Maps API / Auth0 machine codes from passwordless + flex-session JSON errors to i18n ids.
 * See AuthenticationPage.auth0Error.* in translation files.
 */
export const AUTH0_INLINE_ERROR_CODE_TO_MESSAGE_ID = {
  invalid_email: 'AuthenticationPage.auth0Error.invalidEmail',
  rate_limited: 'AuthenticationPage.auth0Error.rateLimited',
  server_misconfigured: 'AuthenticationPage.auth0Error.serverMisconfigured',
  missing_email_or_otp: 'AuthenticationPage.auth0Error.missingEmailOrOtp',
  invalid_otp_format: 'AuthenticationPage.auth0Error.invalidOtpFormat',
  passwordless_start_failed: 'AuthenticationPage.auth0Error.passwordlessStartFailed',
  passwordless_verify_failed: 'AuthenticationPage.auth0Error.passwordlessVerifyFailed',
  missing_id_token: 'AuthenticationPage.auth0Error.missingIdToken',
  invalid_token: 'AuthenticationPage.auth0Error.invalidToken',
  token_missing_email: 'AuthenticationPage.auth0Error.tokenMissingEmail',
  unexpected_flex_response: 'AuthenticationPage.auth0Error.unexpectedFlexResponse',
  flex_idp_login_failed: 'AuthenticationPage.auth0Error.flexIdpLoginFailed',
  flex_idp_login_forbidden: 'AuthenticationPage.auth0Error.flexIdpLoginForbidden',
  'OTP-invalid-response': 'AuthenticationPage.auth0Error.otpInvalidResponse',
  invalid_grant: 'AuthenticationPage.auth0Error.invalidGrant',
  access_denied: 'AuthenticationPage.auth0Error.accessDenied',
  unauthorized_client: 'AuthenticationPage.auth0Error.unauthorizedClient',
  auth0_error: 'AuthenticationPage.auth0Error.auth0Generic',
};

/**
 * @param {Error & { error?: string }} error
 * @param {import('react-intl').IntlShape} intl
 * @param {'start' | 'verify'} phase
 */
export function resolveAuth0InlineErrorMessage(error, intl, phase) {
  const code =
    error && error.error != null && String(error.error).length
      ? String(error.error).trim()
      : error && error.message != null
      ? String(error.message).trim()
      : '';

  const messageId = code ? AUTH0_INLINE_ERROR_CODE_TO_MESSAGE_ID[code] : null;
  if (messageId) {
    return intl.formatMessage({ id: messageId });
  }

  return intl.formatMessage({
    id:
      phase === 'start'
        ? 'AuthenticationPage.passwordlessErrorStart'
        : 'AuthenticationPage.passwordlessErrorVerify',
  });
}
